import { defineMessages } from 'react-intl';

export default defineMessages({
    eaPriorCarrierTitle: {
        id: 'policyjob.components.pni-prior-policy-grid.ea-underwriting-details.Prior Carrier',
        defaultMessage: 'Prior Carrier'
    },
    removeDriverTitle: {
        id: 'policyjob.components.pni-prior-policy-grid.ea-underwriting-details.Confirmation',
        defaultMessage: 'Confirmation'
    },
    removeDriverDescription: {
        id:
      'policyjob.components.pni-prior-policy-grid.ea-underwriting-details.Are you sure to delete the prior carrier details?',
        defaultMessage: 'Are you sure to delete the prior carrier details?'
    },
    primaryNamedInsuredTitle: {
        id: 'policyjob.components.pni-prior-policy-grid.ea-underwriting-details.Primary Named Insured:',
        defaultMessage: 'Primary Named Insured:'
    },
    priorPolicyCarrierNameLabel: {
        id:
      'policyjob.components.pni-prior-policy-grid.ea-underwriting-details.Current/Prior Carrier Name',
        defaultMessage: 'Current/Prior Carrier Name'
    },
    priorPolicyPreviousPolicyLabel: {
        id: 'policyjob.components.pni-prior-policy-grid.ea-underwriting-details.Previous Policy #',
        defaultMessage: 'Previous Policy #'
    },
    priorPolicyYearsWithCompanyLabel: {
        id: 'policyjob.components.pni-prior-policy-grid.ea-underwriting-details.Years w/ company',
        defaultMessage: 'Years w/ company'
    },
    priorPolicyBILimitsLabel: {
        id: 'policyjob.components.pni-prior-policy-grid.ea-underwriting-details.BI Limits',
        defaultMessage: 'BI Limits'
    },
    priorPolicyCoverageLapseLabel: {
        id: 'policyjob.components.pni-prior-policy-grid.ea-underwriting-details.Coverage Lapse',
        defaultMessage: 'Coverage Lapse'
    },
    collisionCoverage: {
        id: 'policyjob.components.pni-prior-policy-grid.ea-underwriting-details.Collision Coverage',
        defaultMessage: 'Collision Coverage'
    },
    comprehensiveCoverage: {
        id: 'policyjob.components.pni-prior-policy-grid.ea-underwriting-details.Comprehensive Coverage',
        defaultMessage: 'Comprehensive Coverage'
    },
    BILimitPP: {
        id: 'policyjob.components.pni-prior-policy-grid.ea-underwriting-details.BI Limit(PP)',
        defaultMessage: 'BI Limit(PP)'
    },
    BILimitPO: {
        id: 'policyjob.components.pni-prior-policy-grid.ea-underwriting-details.BI Limit(PO)',
        defaultMessage: 'BI Limit(PO)'
    },
    BILimitCSL: {
        id: 'policyjob.components.pni-prior-policy-grid.ea-underwriting-details.BI Limit(CSL)',
        defaultMessage: 'BI Limit(CSL)'
    },
    priorPolicyRole: {
        id: 'policyjob.components.pni-prior-policy-grid.ea-underwriting-details.Policy Role',
        defaultMessage: 'Policy Role'
    },
    noPriorPolicies: {
        id: 'policyjob.components.pni-prior-policy-grid.ea-underwriting-details.No prior carrier results',
        defaultMessage: 'No prior carrier results. Please add any prior carriers manually.'
    }
});
